import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import BlogDetailsMain from '../Components/Blog/BlogDetailsMain'
import ScrollToTop from '../Components/ScrollToTop'

function BlogDetails() {
    return (
        <>
            <Breadcrumb
                title="Blog Single"
            />
            <BlogDetailsMain />
            <ScrollToTop />
        </>
    )
}

export default BlogDetails
